import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "./PlanSchema";

export const OrganisationSchema = Yup.object().shape({
  name: StringValidation.label("Name"),
  organisation_type: DropdownValidation.label("Organization type"),
});
